module.exports = __webpack_public_path__ + "media/images/logo_webshop-blue_white-52d11f388927225fbc4f540459ae13fa.svg";